import { setMarketingConsentStatus } from "../../api/customerPreferencesApi";
import { logError, ERROR_TYPE } from "../../utils/newRelicLogger";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import { LOYALTY_MARKETING_CONSENT_SOURCE } from "../../constants";
import AsosWorldModal from "../asosWorldModal/AsosWorldModal";

interface NotifyMeMarketingOptInModalProps {
  open: boolean;
  closeModal: () => void;
  onOptIn: () => void;
  onError: () => void;
}

const NotifyMeMarketingOptInModal = ({
  open,
  closeModal,
  onOptIn,
  onError,
}: NotifyMeMarketingOptInModalProps) => {
  const { getTranslation } = useRuntimeConstants() as {
    getTranslation: (key: string) => string;
  };
  const handleMarketingOptIn = async () => {
    try {
      await setMarketingConsentStatus({
        sourceReason: LOYALTY_MARKETING_CONSENT_SOURCE,
      });
      onOptIn();
    } catch (error) {
      logError(ERROR_TYPE.SdkError, {
        sdk: "customerPreferences",
        action: "setMarketingConsentStatus",
        message: (error as Error).message,
      });
      onError();
    }
  };

  return (
    <AsosWorldModal
      open={open}
      closeModal={closeModal}
      modalId="NotifyMeMarketingOptInModal"
      title={getTranslation("pdp_eap_dialog_title")}
      copy={getTranslation("pdp_eap_dialog_copy")}
      buttonText={getTranslation("pdp_eap_dialog_accept")}
      onButtonClick={handleMarketingOptIn}
    />
  );
};

export default NotifyMeMarketingOptInModal;
